module.exports = __webpack_public_path__ + "static/media/royal_super.bd963541.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/tomate/climasense/tizon_tardio_tomate/curativa/royal_super.png
// module id = 2400
// module chunks = 3